import React from 'react';
import { hasLocationSupport } from '../Common/HOC/LocationSupport';
import { withRouter } from 'react-router';
import autoCompleteFeature from './AutoCompleteFeature';
import config from '../../config';

class AutoCompleteSearchBar extends React.Component {
    constructor(props){
        super(props);
        this.props = props;
        this.state = {
            results: '',
            value: '',
            delayInterval: config.typingDelay,
            limit: 5,
            maxLength: 25,
            enterKeyFlag: false,
            loadingFlag: false,
            onClickOutsideDropDownFlag: false,
            openSearchField: false,
        };
        this.timer;
        const {
            store,
        } = this.props;
    }

    onTextChanged = (event) => {
        document.getElementById('loading').style.visibility = 'visible';
        document.getElementById("search-box").style.borderColor = '#a2bfd5';
        this.setState({onClickOutsideDropDownFlag: false, loadingFlag: false});
        this.search(event, this.state.delayInterval);
    }

    search = (event, delayInterval) => { 
        const value = event.target.value;

        this.setState({enterKeyFlag: false});

        if (value === '') {
            this.setState({results: ''});
            document.getElementById('loading').style.visibility = 'hidden';
        }

        clearTimeout(this.timer);
        this.timer = setTimeout(this.dropDownView, delayInterval, value);
    }

    dropDownView = (value) => {
        this.setState({value: value, loadingFlag: true});

        let query = `?limit=${this.state.limit}&offset=0&query_param=${value}&search_type=product,category`;
        fetch(`${config.localeApi}/search${query}`)
        .then((response) => response.json())
        .then((data) => this.setState({results: data.data.results}));

    }

    handleKeyPress = (event, pathName) => {
        if (event.key === 'Enter') {
            this.props.updateLocationForGlobalSearch(event.target.value, pathName);
            this.setState({results: '', enterKeyFlag: true});
            document.getElementById('loading').style.visibility = 'hidden';
        }
    }
    
    handleOnClickOutsideDropDown = (event) => {
        if (!(event.target.id === 'input-search-bar' || event.target.className.includes('dropdown'))) {
            this.setState({results: ''});
            document.getElementById("search-box").style.borderColor = "#D9D9D9";
            document.getElementById('loading').style.visibility = 'hidden';
            this.setState({onClickOutsideDropDownFlag: true});
        } else {
            this.setState({onClickOutsideDropDownFlag: false});
        }
    };
    
    handleSearchAll = (query) => {
        const pathName = this.props.tRoute('/search');
        this.props.updateLocationForGlobalSearch(query, pathName);
        this.setState({results: '', enterKeyFlag: true});
        document.getElementById('loading').style.visibility = 'hidden';
        document.getElementById("search-box").style.borderColor = "#D9D9D9";
    }

    onClickSearchBox = (event) => {
        document.getElementById("search-box").style.borderColor = '#a2bfd5';
        if (event.target.value !== '') {
            this.search(event, 0);
        }
    }

    renderSuggestions() {  
        const products = this.state.results;
        const currency = this.props.store.currency.symbol;

        if (this.state.enterKeyFlag || this.state.onClickOutsideDropDownFlag || !products) {
            return null;
        }

        if (this.state.loadingFlag){
            document.getElementById('loading').style.visibility = 'hidden';
        }

        const { 
            categories,
            themes,
            categoryIsEmpty,
            themeIsEmpty,
        } = this.props.renderSuggestions(products);

        return (
            <div>
                <div className="arrow"></div>
                {this.props.showDropDown(categories, themes, categoryIsEmpty, themeIsEmpty, currency, this.state, this.handleSearchAll)}
            </div>
        )
    }
    
    componentDidMount() {
        document.addEventListener("click", this.handleOnClickOutsideDropDown);
    }
    
    componentWillUnmount() {
        document.removeEventListener("click", this.handleOnClickOutsideDropDown);
    }

    render() {
        return (
            <div className="AutoCompleteSearchBar" id="search-box">
                <i className="fa fa-search mt-2 search-icon-top"></i>
                <input 
                    id="input-search-bar" 
                    type="text" 
                    placeholder="Search..." 
                    onChange={this.onTextChanged} 
                    onKeyPress={(event) => this.handleKeyPress(event, this.props.tRoute('/search'))}
                    onClick={(event) => this.onClickSearchBox(event)}
                    autoComplete="off"
                />
                <i id="loading" className="fa fa-spinner fa-spin load-icon"/>
                {this.renderSuggestions()}
            </div>
        )
    }
}

export default withRouter(hasLocationSupport(autoCompleteFeature(AutoCompleteSearchBar)));



// WEBPACK FOOTER //
// ./src/Nav/AutoCompleteSearchBar.js